<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板 View 组件，为了兼容第三层 router-view
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <router-view />
</template>

<script>
export default {
  name: 'TheLayoutView'
}
</script>
